
// Authentication
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
// import VerifyOTP from "../pages/Authentication/VerifyOTP";

// Dashboard
import Dashboard from "../pages/protected/Dashboard";

import Users from "../pages/protected/User/Users";
import AddEditUser from "../pages/protected/User/AddEditUser";
import UserView from "../pages/protected/User/UserView";

import Expertize from "../pages/protected/Expertise/Expertize";
import SubExpertise from "../pages/protected/Expertise/SubExpertise";


import Topic from "../pages/protected/Topic/Topic";

import SubTopic from "../pages/protected/Topic/SubTopic";

import Interest from "../pages/protected/Interest/Interests";

import QuestionList from "../pages/protected/Question/QuestionList";
import QuestionDetails from "../pages/protected/Question/QuestionDetails";

import Cities from "../pages/protected/City/Cities";

import Hallofsages from "../pages/protected/HallOFSages";


const protectedRoutes = [
    { path: "/dashboard", component: Dashboard},
    { path: "/hallofsages", component: Hallofsages},
    { path: "/cities", component: Cities},
    { path: "/questions/user/:userid", component: QuestionList},
    { path: "/questions/:id", component: QuestionDetails},
    { path: "/questions", component: QuestionList},
    { path: "/interests", component: Interest},
    { path: "/subtopic", component: SubTopic},
    { path: "/topic", component: Topic},
    { path: "/subexpertise", component: SubExpertise},
    { path: "/expertize", component: Expertize},
    { path: "/users/edit/:id", component: AddEditUser},
    { path: "/users/view/:id", component: UserView},
    { path: "/users/add", component: AddEditUser},
    { path: "/users", component: Users},
    { path: "/", component: Dashboard}
];

const publicRoutes = [
    { path: "/login", component: Login },
    { path: "/logout", component: Logout },    
];

export { protectedRoutes, publicRoutes };